let publicFunction = {
  //获取单价单位
  unitAppend(bankInfo) {
    const unitTimeOption = {
      0: "无",
      1: "年 ",
      2: "季度 ",
      3: "月 ",
    };
    if (bankInfo.bidType == 1) {
      return `${
        (bankInfo.unitNum == "无" || !bankInfo.unitNum
          ? ""
          : "/" + bankInfo.unitNum) +
        (bankInfo.unitTime == "0" || !bankInfo.unitTime
          ? ""
          : "/" + unitTimeOption[bankInfo.unitTime])
      }`;
    } else {
      return "";
    }
  },
  // JSON转URL参数
  parseParams(data) {
    try {
      let tempArr = [];
      for (let i in data) {
        let key = encodeURIComponent(i);
        let value = encodeURIComponent(data[i]);
        tempArr.push(key + "=" + value);
      }
      let urlParamsStr = tempArr.join("&");
      return urlParamsStr;
    } catch (err) {
      return "";
    }
  },
  //将base64转换为blob
  dataURLtoBlob(dataurl) {
    let arr = dataurl.split(",");
    let mime = arr[0].match(/:(.*?);/)[1];
    let bstr = atob(arr[1]);
    let n = bstr.length;
    let u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], {
      type: mime,
    });
  },
  //将blob转换为file
  blobToFile(theBlob, fileName) {
    theBlob.lastModifiedDate = new Date();
    theBlob.name = fileName;
    return theBlob;
  },
  getNowTime() {
    let date = new Date();
    let Year = date.getFullYear();
    let Month = date.getMonth() + 1;
    let Day = date.getDate();
    let Hours = date.getHours();
    let Minutes = date.getMinutes();
    let Seconds = date.getSeconds();
    if (Month >= 1 && Month <= 9) {
      Month = "0" + Month;
    }
    if (Day >= 0 && Day <= 9) {
      Day = "0" + Day;
    }
    if (Hours >= 1 && Hours <= 9) {
      Hours = "0" + Hours;
    }
    if (Minutes >= 0 && Minutes <= 9) {
      Minutes = "0" + Minutes;
    }
    if (Seconds >= 0 && Seconds <= 9) {
      Seconds = "0" + Seconds;
    }
    let nowDate =
      Year +
      "-" +
      Month +
      "-" +
      Day +
      " " +
      Hours +
      ":" +
      Minutes +
      ":" +
      Seconds;
    return nowDate;
  },
  getDaysInOneMonth(year, month) {
    month = parseInt(month, 10);
    let day = new Date(year, month, 0);
    return day.getDate();
  },
  getTodayDate() {
    // 获取当前日期
    let date = new Date();
    // 获取当前月份
    let nowMonth = date.getMonth() + 1;
    // 获取当前是几号
    let strDate = date.getDate();
    // 对月份进行处理，1-9月在前面添加一个“0”
    if (nowMonth >= 1 && nowMonth <= 9) {
      nowMonth = "0" + nowMonth;
    }
    // 对月份进行处理，1-9号在前面添加一个“0”
    if (strDate >= 0 && strDate <= 9) {
      strDate = "0" + strDate;
    }
    // 最后拼接字符串，得到一个格式为(yyyy-MM-dd)的日期
    let nowDate = date.getFullYear() + "-" + nowMonth + "-" + strDate;
    return nowDate;
  },
  getThisMonth() {
    // 获取当前日期
    let date = new Date();
    // 获取当前月份
    let nowMonth = date.getMonth() + 1;
    // 对月份进行处理，1-9月在前面添加一个“0”
    if (nowMonth >= 1 && nowMonth <= 9) {
      nowMonth = "0" + nowMonth;
    }
    // 最后拼接字符串，得到一个格式为(yyyy-MM)的日期
    let nowDate = date.getFullYear() + "-" + nowMonth;
    return nowDate;
  },
  getThisYear() {
    // 获取当前日期
    let date = new Date();
    // 获取当前年份
    let nowDate = date.getFullYear();
    return nowDate;
  },
  toType(obj) {
    return {}.toString
      .call(obj)
      .match(/\s([a-zA-Z]+)/)[1]
      .toLowerCase();
  },
  //
  filterNull(o) {
    for (var key in o) {
      if (o[key] === null) {
        delete o[key];
      }
      if (publicFunction.toType(o[key]) === "string") {
        o[key] = o[key].trim();
      } else if (publicFunction.toType(o[key]) === "object") {
        o[key] = publicFunction.filterNull(o[key]);
      } else if (publicFunction.toType(o[key]) === "array") {
        o[key] = publicFunction.filterNull(o[key]);
      }
    }
    return o;
  },
  lcDeepCopy(obj) {
    // 根据obj的类型判断是新建一个数组还是对象
    let newObj = Array.isArray(obj) ? [] : {};
    // 判断传入的obj存在，且类型为对象
    if (obj && typeof obj === "object") {
      for (let key in obj) {
        // 如果obj的子元素是对象，则进行递归操作
        if (obj[key] && typeof obj[key] === "object") {
          newObj[key] = publicFunction.lcDeepCopy(obj[key]);
        } else {
          // // 如果obj的子元素不是对象，则直接赋值
          newObj[key] = obj[key];
        }
      }
    }
    return newObj; // 返回新对象
  },
  //
  deepCopy(object, beCopied) {
    for (let i in object) {
      if (Object.prototype.toString.call(beCopied[i]) === "[object String]") {
        object[i] = JSON.parse(JSON.stringify(beCopied[i]));
      } else if (
        Object.prototype.toString.call(beCopied[i]) === "[object Number]"
      ) {
        object[i] = JSON.parse(JSON.stringify(beCopied[i]));
      } else if (
        Object.prototype.toString.call(beCopied[i]) === "[object Object]"
      ) {
        publicFunction.deepCopy(object[i], beCopied[i]);
      } else if (
        Object.prototype.toString.call(beCopied[i]) === "[object Undefined]"
      ) {
        //
      } else if (
        Object.prototype.toString.call(beCopied[i]) === "[object Boolean]"
      ) {
        object[i] = JSON.parse(JSON.stringify(beCopied[i]));
      } else if (
        Object.prototype.toString.call(beCopied[i]) === "[object Array]"
      ) {
        object[i] = JSON.parse(JSON.stringify(beCopied[i]));
      } else if (
        Object.prototype.toString.call(beCopied[i]) === "[object Null]"
      ) {
        object[i] = "";
      } else {
        object[i] = "";
      }
    }
    return object;
  },
  //
  getQueryString(name) {
    let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
    let r = window.location.href.substr(1).match(reg);
    if (r != null) {
      return unescape(r[2]);
    }
    return null;
  },
  //时间转为刚刚，几分钟前，几小时前，几天前
  dateTransfer(date) {
    // debugger
    //获取js 时间戳
    var time = new Date();
    time.setHours(time.getHours() + time.getTimezoneOffset() / 60);
    time = time.getTime();
    //去掉 js 时间戳后三位，与php 时间戳保持一致
    time = parseInt(time - date);
    //存储转换值
    var s;
    if (time < 60 * 10) {
      //十分钟内
      return "刚刚";
    } else if (time < 60 * 60 && time >= 60 * 10) {
      //超过十分钟少于1小时
      s = Math.floor(time / 60);
      return s + "分钟前";
    } else if (time < 60 * 60 * 24 && time >= 60 * 60) {
      //超过1小时少于24小时
      s = Math.floor(time / 60 / 60);
      return s + "小时前";
    } else if (time < 60 * 60 * 24 * 3 && time >= 60 * 60 * 24) {
      //超过1天少于3天内
      s = Math.floor(time / 60 / 60 / 24);
      return s + "天前";
    } else {
      //超过3天
      var date = new Date(date);
      return (
        date.getFullYear() + "/" + (date.getMonth() + 1) + "/" + date.getDate()
      );
    }
  },
  /**
   * 解决使用 moment.js 格式化本地时间戳时多出了 8 小时问题，这 8 小时是本地时间与格林威治标准时间 (GMT) 的时差
   * 例如：moment(5 * 60 * 1000)，将 5 分钟的本地时间戳转为日期，结果会多出 8 小时，就是解决此问题
   * @param {Number} time 本地时间戳
   */
  fixTimezoneOffset(time) {
    const date = new Date(time);
    // 当前时间 = 包含时差的当前时间 + 时差时间，getTimezoneOffset() 获取时差（以分钟为单位），转为小时需要除以 60
    date.setHours(date.getHours() + date.getTimezoneOffset() / 60);
    return date.getTime();
  },
  // 校验身份证
  isIdCard(card) {
    let reg = /(^\d{15}$)|(^\d{17}([0-9]|X)$)/;
    return reg.test(card);
  },
  // 校验手机号码
  isPhone(phone) {
    let reg = /^1[3456789]\d{9}$/;
    return reg.test(phone);
  },
  // 校验座机号
  isTel(phone) {
    let reg = /^(\(\d{3,4}\)|\d{3,4}-|\s)?\d{7,14}$/;
    return reg.test(phone);
  },
  // 校验银行卡
  isBank(card) {
    let reg = /^(?:[1-9]{1})(?:\d{15}|\d{18})$/;
    return reg.test(card);
  },
  // 校验邮箱
  isEmail(email) {
    let reg = /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/;
    return reg.test(email);
  },
  //设置cookie
  setCookie(c_name, c_pwd, exdays) {
    var exdate = new Date(); //获取时间
    exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * exdays); //保存的天数
    //字符串拼接cookie
    window.document.cookie =
      "userNameRPRT" + "=" + c_name + ";path=/;expires=" + exdate.toGMTString();
    window.document.cookie =
      "userPwdRPRT" + "=" + c_pwd + ";path=/;expires=" + exdate.toGMTString();
  },
  // 获取URL参数值
  getURLParams(name, url) {
    name = name.replace(/[[]]/g, "\\$&");
    let regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)");
    let results = regex.exec(url);
    if (!results) return "";
    if (!results[2]) return "";
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  },
};

export default publicFunction;
